import React from 'react';
import styled from 'styled-components';
import { LoadingSpinner, Dropdown } from 'yankees-react-utils';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import opponents from '../../images/opponents.png';
import { Team as teamData, useCachedOktaQuery } from '../../data';
import usePlayerSelector from '../../utils/usePlayerSelector';

const CardImage = styled.img`
    height: 80px;
    width: 120px;
    object-fit: cover;
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
`;

const OpponentsCard = () => {
    const { t: translate } = useTranslation();
    const { Team } = usePlayerSelector();
    const history = useHistory();

    const onSelect = ({ teamId }) => {
        if (teamId) {
            history.push(`/opponent/${teamId}`);
        }
    };
    const { data: teams, isLoading } = useCachedOktaQuery(
        ['search-teams', Team.Level.LevelID],
        (te) => teamData.bylevel(te, Team.Level.LevelID),
        {}, 1000 * 60 * 60 * 12,
    );
    const getTeamDisplayName = (te) => `${te.FullName}`;

    const cleanTeams = teams?.filter((te) => !te.IsNYYOrganization) ?? [];
    cleanTeams.sort((a, b) => getTeamDisplayName(a) - getTeamDisplayName(b));
    const teamOptions = [{ name: translate('common.select-a-team'), value: '' }, ...cleanTeams.map((ct) => ({ name: getTeamDisplayName(ct), teamId: ct.TeamID }))];

    return (
        <div className="shadow-sm border mb-2 rounded d-flex bg-white align-items-center">
            <CardImage src={opponents} alt="Opponents" />
            <div className="px-4">
                <h4 className="mb-1 text-primary">{translate('home.opponents')}</h4>
                {isLoading ? <LoadingSpinner />
                    : (
                        <Dropdown options={teamOptions} value={translate('common.select-a-team')} onSelect={onSelect} />
                    ) }
            </div>
        </div>
    );
};

export default OpponentsCard;
